import { Alert, Button } from "@mui/material";
import React, { useState } from "react";

import useAuth from "../hooks/useAuth";
import { LEGACY, isCookieAuth, switchAuthProvider } from "../lib/authProvider";
import { trackEvent } from "../utils/analytics";

// Shown only on the cookie path, so the legacy path stays unchanged for anyone
// who never opted in. Also the way out for someone the new path turns away.
function AuthPathBanner(props) {
  const [switching, setSwitching] = useState(false);
  const { user } = useAuth();

  if (!isCookieAuth()) return null;

  // No user yet on the sign-in page, and not every account has a given name.
  const firstName = user?.first_name?.trim();

  const handleSwitchBack = () => {
    setSwitching(true);
    trackEvent("auth_path_switch", { to: LEGACY });
    switchAuthProvider(LEGACY);
  };

  return (
    <Alert
      severity="info"
      action={
        <Button
          color="inherit"
          size="small"
          onClick={handleSwitchBack}
          disabled={switching}
          sx={{ whiteSpace: "nowrap" }}
        >
          Switch back
        </Button>
      }
      {...props}
    >
      <strong>New authorization unlocked!</strong>{" "}
      {firstName
        ? `Thanks ${firstName} for living on the cutting edge!`
        : "Thanks for living on the cutting edge!"}
    </Alert>
  );
}

export default AuthPathBanner;
